<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ editMode ? "Edit" : "Add" }} Carrier Service
        <i class="caption red--text ml-4"> * required field</i>
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="6" md="6" class="pb-0">
              <v-select
                v-model="editedItem.carrier_id"
                label="Carrier Name"
                class="required pt-0 pb-0"
                item-text="name"
                item-value="id"
                :items="activeCarriersListTypes"
                :rules="[(v) => !!v || 'Carrier Name is required.']"
                outlined
                :disabled="editMode == true"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0">
              <v-text-field
                v-model="editedItem.carrier_service"
                label="Carrier Service Name"
                maxlength="100"
                :rules="[
                  (v) =>
                    new RegExp('[a-zA-Z]').test(v) ||
                    'Carrier Service Name should contain at least 1 alphabet.',
                  (v) =>
                    (!!v && v.length > 0) ||
                    'Carrier Service Name is required and should contain at least 1 character.',
                ]"
                class="required"
                outlined
                :disabled="editMode == true"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-text-field
                v-model="editedItem.carrier_service_code"
                label="Carrier Service Code"
                maxlength="100"
                :rules="[
                  (v) =>
                    (!!v && !/[^a-zA-Z0-9]/g.test(v)) ||
                    'Carrier Service Code should contain only alphanumeric characters.',
                ]"
                class="required"
                outlined
                :disabled="editMode == true"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-autocomplete
                v-model="editedItem.status"
                :items="statuses"
                item-text="text"
                item-value="value"
                label="Status"
                :rules="[(v) => v == 0 || v == 1 || 'Status is required.']"
                class="required"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-autocomplete
                v-model="editedItem.delivery_type"
                :items="deliveryTypes"
                outlined
                chips
                item-text="text"
                item-value="value"
                small-chips
                label="Delivery Type"
                multiple
                @input="getService(editedItem.delivery_type)"
                :rules="[(v) => v.length > 0 || 'Delivery Type is required.']"
                class="required"
                :disabled="editMode == true"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-autocomplete
                v-model="editedItem.rsa_service_types"
                :items="rsaserviceList"
                outlined
                chips
                :item-text="
                  (item) => `${item.service_name} - (${item.service_code})`
                "
                item-value="id"
                small-chips
                label="RSA Service Code"
                :rules="[(v) => !!v || 'RSA Service Code is required.']"
                class="required"
                :loading="rsaserviceListLoader"
                :open-on-clear="false"
                :menu-props="{ bottom: true, offsetY: true }"
                :disabled="editMode == true"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0 pt-0">
              <v-textarea
                v-model="editedItem.carrier_service_description"
                label="Description"
                outlined
                dense
                class="required"
                :rules="[(v) => !!v || 'Description is required.']"
                maxlength="255"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="primary"
          class="ml-2 mb-4"
          v-if="editMode == false"
          @click="save"
          >Save</v-btn
        >
        <v-btn
          color="primary"
          class="ml-2 mb-4"
          v-if="editMode == true"
          @click="save"
          >Update</v-btn
        >
        <v-btn color="white" class="mb-4" @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory", "activeCarriersListTypes"]),
  },
  data: () => ({
    rsaserviceListLoader: false,
    is_add_edit: false,
    editMode: false,
    dialog: false,
    deliveryTypes: [
      { text: "Crossborder", value: "crossborder" },
      { text: "Domestic", value: "domestic" },
    ],
    statuses: [
      { text: "Active", value: 1 },
      { text: "In-Active", value: 0 },
    ],
    editedItem: {
      carrier_service_code: null,
      carrier_service: null,
      carrier_service_description: null,
      status: null,
      rsa_service_types: null,
      delivery_type: [],

      carrier_id: null,
    },
    service_code: null,
    service_name: null,
    status: null,
    delivery_type: [],

    options: {},
    total: 0,
    serviceListLoader: false,
    filtersArr: [],
    serviceList: [],
    carrier: null,
    downloader: false,
    selectedCarriedId: null,
    rsaserviceList: [],
  }),

  watch: {
    options: {
      handler() {
        this.fetchServiceList();
      },
      deep: true,
    },
  },

  async created() {
    this.getActiveCarriersListTypes();

    if (this.$route.params.id > 0) {
      this.getCarrierService(this.$route.params.id).then((res) => {
        this.editedItem = res.data.records[0];
        this.editMode = true;
        this.editedItem.rsa_service_types =
          this.editedItem.rsa_service_types_id;
        this.editedItem.delivery_type = this.editedItem.delivery_type
          .split(",")
          .map((item) => {
            return item.trim();
          });
        this.getService(this.editedItem.delivery_type);
      });
    } else {
      this.editMode = false;
    }
  },
  methods: {
    ...mapActions([
      "snackBar",
      "addCarrierService",
      "getCarrierService",
      "updateCarrierService",
      "getActiveCarriersListTypes",
      "getRSAServiceListOnly",
    ]),
    getService(service) {
      this.rsaserviceListLoader = true;
      service = Array.isArray(service) ? service.join(",") : service;
      this.getRSAServiceListOnly(service).then((res) => {
        this.rsaserviceList = res.data;
        this.rsaserviceListLoader = false;
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      let obj = {
        carrier_service_description:
          this.editedItem.carrier_service_description,
        carrier_service: this.editedItem.carrier_service,
        carrier_service_code: this.editedItem.carrier_service_code,
        status: this.editedItem.status,
        delivery_type: Array.isArray(this.editedItem.delivery_type)
          ? this.editedItem.delivery_type.join(",")
          : this.editedItem.delivery_type,
        rsa_service_types: this.editedItem.rsa_service_types,
        carrier_id: this.editedItem.carrier_id,
      };
      if (this.editMode == false) {
        this.addCarrierService(obj).then((result) => {
          this.snackBar({
            color: "success",
            message: result.data.message,
          });
          this.dialog = false;
          this.$refs.form.reset();
          this.$router.push({ name: "CarriersServices" });
        });
      } else {
        (this.editedItem.delivery_type = Array.isArray(
          this.editedItem.delivery_type
        )
          ? this.editedItem.delivery_type.join(",")
          : this.editedItem.delivery_type),
          this.updateCarrierService(this.editedItem).then((result) => {
            this.snackBar({
              color: "success",
              message: result.data.message,
            });
            this.dialog = false;
            this.$refs.form.reset();
            this.$router.push({ name: "CarriersServices" });
          });
      }
    },
    close() {
      this.$refs.form.reset();
      this.editMode = false;
      this.$router.push({ name: "CarriersServices" });
    },
  },
};
</script>
